import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Stack, Typography} from 'views/components';
import {SimpleRefreshWidget, Translate, translate} from 'views/module';

import moment from 'moment';

// Loom has no CareOS writes, so the header has no action to add a client.
const Header = (props) => {
  const {
    lastUpdatedAt,
    numRefresh,
    setLastUpdatedAt,
    setNumRefresh,
  } = props;

  const summaryLabel = translate('loomLead.LoomLeadList.Header.Summary', {
    updatedTime: moment(lastUpdatedAt).format('h:mm A'),
  });

  return (
    <Stack
      sx={{
        width: '100%',
        gap: '12px',
      }}
    >
      <Stack
        sx={{
          gap: '8px',
        }}
      >
        <Typography
          sx={{
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '28px',
            lineHeight: '36px',
            color: '#1A1916',
          }}
        >
          <Translate expression='loomLead.LoomLeadList.Title' />
        </Typography>
        <Stack
          direction={{md: 'row', xs: 'column'}}
          justifyContent='space-between'
          alignItems={{md: 'center', xs: 'flex-start'}}
          sx={{
            gap: '12px',
          }}
        >
          <Typography
            sx={{
              fontStyle: 'normal',
              fontWeight: 400,
              fontSize: '13px',
              lineHeight: '17px',
              color: '#A8A49E',
            }}
          >
            {summaryLabel}
          </Typography>
          <Stack
            direction='row'
            alignItems='center'
            sx={{
              gap: '10px',
              flexWrap: 'wrap',
              ml: {md: 'auto', xs: 0},
            }}
          >
            <SimpleRefreshWidget
              numRefresh={numRefresh}
              setNumRefresh={setNumRefresh}
              setLastUpdatedAt={setLastUpdatedAt}
            />
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

Header.propTypes = {
  lastUpdatedAt: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]).isRequired,
  numRefresh: PropTypes.number.isRequired,
  setLastUpdatedAt: PropTypes.func.isRequired,
  setNumRefresh: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(Header));
